export const projects = [
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/mates.png",
  //   name: "Donors",
  //   ext: "jsx",
  //   lang: "js",
  //   git: "https://youtu.be/Zm4ptkIXlTA",
  //   live: "http://mw.mait.ac.in/",
  // },
   {
    img: "https://i.ibb.co/QMbb17P/Screenshot-600.png",
    name: "Codash",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/codash",
    live: "https://codash-plum.vercel.app/",
   },
  {
    img: "https://i.ibb.co/R7j6ZZN/Screenshot-3001.png",
    name: "Sasta-Youtube",
    ext: "Vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/sasta-youtube",
    live: "https://sasta-youtube-omega.vercel.app/",
  },
  {
    img: "https://i.ibb.co/5hWrt9fg/Screenshot-2091.png",
    name: "Rhinosfightclub",
    ext: "Vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/fight-club-vibes-web",
    live: "https://rhinosfightclub.com/",
  },
  {
    img: "https://i.ibb.co/GQWRP21h/Screenshot-1381.png",
    name: "Pathfinder",
    ext: "pages.dev",
    lang: "html n css",
    git: "https://github.com/VanshajPoonia/Pathfinder-visualiser",
    live: "https://pathfindingvisualizer.pages.dev/",
  },
  {
    img: "https://i.ibb.co/4nRqv3d2/Screenshot-1382.png",
    name: "Kode",
    ext: "pages.dev",
    lang: "html n css",
    git: "https://github.com/VanshajPoonia/kode",
    live: "http://kode.pages.dev/",
  },
  {
    img: "https://i.ibb.co/4PDncyW/Screenshot-1913.png",
    name: "Vanshajpoonia",
    ext: "netlify.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/portfoliosite-sanity-jsm",
    live: "https://vanshajpoonia.netlify.app/",
  },
  // {
  //   img: "https://i.ibb.co/RC6NTKV/Screenshot-1889.png",
  //   name: "Poogle",
  //   ext: "vercel.app",
  //   lang: "ssr",
  //   git: "https://github.com/VanshajPoonia/poogle",
  //   live: "https://poogle.vercel.app/",
  // },
  // {
  //   img: "blob:https://vercel.com/7bf659d7-f28c-4005-905e-f233fdcd5ba1",
  //   name: "Devify",
  //   ext: "vercel.app",
  //   lang: "ssr",
  //   git: "https://github.com/VanshajPoonia/devify",
  //   live: "https://devify-smoky.vercel.app/",
  // },
  // {
  //   img: "https://i.ibb.co/RC6NTKV/Screenshot-1889.png",
  //   name: "Hostman",
  //   ext: "vercel.app",
  //   lang: "react",
  //   git: "https://github.com/VanshajPoonia/hostman",
  //   live: "https://github.com/VanshajPoonia/hostman",
  // },
  // {
   // img: "https://camo.githubusercontent.com/23000000d45d4003e5080ce3c7e5bb245bf5bd169c9a9315615bb8bf36de6be6/68747470733a2f2f73372e67696679752e636f6d2f696d616765732f53637265656e73686f742d323730372e706e67",
   // name: "Announcerrr",
   // ext: "vercel.app",
   // lang: "svelte",
   // git: "https://github.com/VanshajPoonia/announerrr",
   // live: "https://announcerrr.vercel.app",
 // },
 // {
 //   img: "https://camo.githubusercontent.com/463efda08223623a4041d18e78a17427cc5729e6185b89af1c17aded5a0e9af3/68747470733a2f2f73342e67696679752e636f6d2f696d616765732f657a6769662e636f6d2d6769662d6d616b6572333336643662623061303934373836302e676966",
 //   name: "Shopeee",
 //  ext: "vue.js",
 //   lang: "js",
 //   git: "https://github.com/VanshajPoonia/shopeee",
 //   live: "https://github.com/VanshajPoonia/shopeee",
 // },
  // {
  //   img: "https://i.ibb.co/DtMz2Xj/Screenshot-1894.png",
  //   name: "Cryptoverse",
  //   ext: "hypnosys.in",
  //   lang: "ssr",
  //   git: "https://github.com/VanshajPoonia/cryptoverse",
  //   live: "https://cryptoverse.hypnosys.in/",
  // },
  {
    img: "https://user-images.githubusercontent.com/74147463/138558499-e9bdf137-ab10-44b6-9842-6bf772f2c87f.png",
    name: "Vanshaj Poonia",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/vanshajpoonia.vercel.app",
    live: "https://vanshajpoonia.vercel.app/",
  },
  {
    img: "https://devfolio.co/_next/image?url=https%3A%2F%2Fassets.devfolio.co%2Fhackathons%2F477fc44df3b94017b8b4bef44fca3cd7%2Fprojects%2Fff4fcb481e14456f9c02961cc3c255c9%2Feeea2c87-3800-4fe5-8fa7-ff484d0abc5d.png&w=1024&q=75",
    name: "D-Drive",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://devfolio.co/projects/decentralize-drive-db2f",
    live: "https://devfolio.co/projects/decentralize-drive-db2f",
  },
  // {
  //   img: "https://i.ibb.co/txcGjwT/Screenshot-1892.png",
  //   name: "Krypt",
  //   ext: "hypnosys.in",
  //   lang: "ssr",
  //   git: "https://github.com/VanshajPoonia/krypt",
  //   live: "https://krypt.hypnosys.in/",
  // },
  // {
  //   img: "https://i.ibb.co/VVdP4Jz/Screenshot-1897.png",
  //   name: "Discord Clone",
  //   ext: "vercel.app",
  //   lang: "ssr",
  //   git: "https://github.com/VanshajPoonia/discord-clone-blockchain",
  //   live: "https://discord-clone-blockchain-vanshajpoonia.vercel.app/",
  // },
  {
    img: "https://user-images.githubusercontent.com/74147463/138558412-e8b7fa8b-0577-40bf-8d04-d6e6cc4a4b31.png",
    name: "Moogle",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/moogle",
    live: "https://moogle.vercel.app/",
  },
  {
    img: "https://i.ibb.co/YTRx9Jqq/Screenshot-2088.png",
    name: "Codashmeet",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/interview-platform",
    live: "https://interview-platform-vanshajpoonia.vercel.app/",
  },
  {
    img: "https://user-images.githubusercontent.com/74147463/138558703-30e5f099-18c9-4221-93eb-464bdbb2aa9b.png",
    name: "Physicsviz",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/physicsviz",
    live: "https://physicsviz.vercel.app/",
  },
  {
    img: "https://i.ibb.co/dYr6CcZ/Screenshot-2098.png",
    name: "Yahn",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/bitrelay-cloud-bloom",
    live: "https://bitrelaysystems.vercel.app/",
  },
  {
    img: "https://i.ibb.co/ZprvL1wm/Screenshot-2097.png",
    name: "Yahn",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/yahn-time-catalogue-elegance",
    live: "https://yahn-nu.vercel.app",
  },
  {
    img: "https://i.ibb.co/svHfm0Fy/Screenshot-2095.png",
    name: "Hypnosys",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/lux-consultancy-3d-glide",
    live: "https://hypnosys.vercel.app/",
  },
  // {
  //   img: "https://i.ibb.co/txcGjwT/Screenshot-1892.png",
  //   name: "Krypt",
  //   ext: "hypnosys.in",
  //   lang: "ssr",
  //   git: "https://github.com/VanshajPoonia/krypt",
  //   live: "https://krypt.hypnosys.in/",
  // },
  {
    img: "https://i.ibb.co/Pv8M0cqg/Screenshot-2099.png",
    name: "TheMarketingAlliance",
    ext: "pages.dev",
    lang: "html n css",
    git: "https://github.com/VanshajPoonia/",
    live: "https://themarketingalliance.pages.dev/",
  },
  {
    img: "https://i.ibb.co/4gn16SMw/Screenshot-2090.png",
    name: "Hypnobank",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/hoobank",
    live: "https://hypnobank.vercel.app",
  },
  
  {
    img: "https://i.ibb.co/70Fb3Kb/Screenshot-1374.png",
    name: "Vander",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/vander",
    live: "https://vander-beige.app/",
  },
  {
    img: "https://i.ibb.co/vVHK9Qn/Screenshot-1900.png",
    name: "Amazon Prime clone",
    ext: "vercel.app",
    lang: "react",
    git: "https://github.com/VanshajPoonia/amazonprime-react",
    live: "https://amazonprime-react.vercel.app/",
  },
  {
    img: "https://i.ibb.co/R4NT1HcK/Screenshot-2092.png",
    name: "Zenquanta.AI",
    ext: "vercel.app",
    lang: "react",
    git: "https://github.com/VanshajPoonia/zenquanta-ai-genesis-web",
    live: "https://zenquantaai.vercel.app/",
  },
  // {
  //   img: "https://i.ibb.co/d2yt61s/Screenshot-1896.png",
  //   name: "Twitter-clone",
  //   ext: "vercel.app",
  //   lang: "ssr",
  //   git: "https://github.com/VanshajPoonia/twitter-clone-blockchain",
  //   live: "https://twitter-clone-blockchain-vanshajpoonia.vercel.app/",
  // },
  
  
  // {
  //   img: "https://i.ibb.co/CBnNvnM/Screenshot-1902.png",
  //   name: "Codashmeet",
  //   ext: "hypnosys.in",
  //   lang: "react",
  //   git: "https://github.com/VanshajPoonia/codashmeet",
  //   live: "https://codashmeet.hypnosys.in"
  // },
  {
    img: "https://i.ibb.co/SVbfjs7/Screenshot-494.png",
    name: "Vanshaj",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/portfolio-site-nextjs",
    live: "https://vanshaj.vercel.app"
  },
//  {
//    img: "https://res.cloudinary.com/practicaldev/image/fetch/s--a5kaccIG--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_66%2Cw_880/https://thumbs.gfycat.com/FreshAnyHanumanmonkey-size_restricted.gif",
//    name: "Jarvis",
//    ext: "py",
//    lang: "py",
//    git: "https://github.com/VanshajPoonia/jarvis",
//    live: "https://github.com/VanshajPoonia/jarvis",
//  },
  // {
  //   img: "https://i.ibb.co/vBGW5Pv/Screenshot-1898.png",
  //   name: "Openseaclone",
  //   ext: "vercel.app",
  //   lang: "ssr",
  //   git: "https://github.com/VanshajPoonia/opensea-clone",
  //   live: "https://opensea-clone-vanshajpoonia.vercel.app/",
  // },
  // {
  //   img: "https://user-images.githubusercontent.com/74147463/138559132-3ba64b6e-a275-4ad6-ae3d-a804ffafa3a3.png",
  //   name: "Cryptant",
  //   ext: "",
  //   lang: "hybrid",
  //   git: "https://github.com/VanshajPoonia/cryptant",
  //   live: "https://github.com/VanshajPoonia/cryptant",
  // },
  {
    img: "https://i.ibb.co/GfsNjnG0/Screenshot-2093.png",
    name: "Novaquarklabs",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/novaquark-aether-webscape",
    live: "https://novaquarklabs.vercel.app/",
  },
  {
    img: "https://i.ibb.co/k2HjHWt/Screenshot-1899.png",
    name: "Shareme",
    ext: "netlify.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/shareme",
    live: "https://shareme-vanshajpoonia.netlify.app/",
  },
  {
    img: "https://i.ibb.co/8DmGqNGm/Screenshot-1378.png",
    name: "RelacsUI",
    ext: "pages.dev",
    lang: "html n css",
    git: "https://github.com/VanshajPoonia/relacsui",
    live: "https://relacsui.pages.dev/",
  },
//  {
//    img: "https://user-images.githubusercontent.com/74147463/138558144-d1392fe7-88f6-4f31-bf38-2daf2020c888.png",
//    name: "Hammr",
//    ext: "pages.dev",
//    lang: "html n css",
//    git: "https://github.com/VanshajPoonia/hammr",
//    live: "https://hammr.org/",
//  },
  {
    img: "https://user-images.githubusercontent.com/74147463/138559454-246c1258-54ad-4cbb-b50c-9e2279d16ad7.jpeg",
    name: "Friday",
    ext: "py",
    lang: "py",
    git: "https://github.com/VanshajPoonia/friday",
    live: "https://github.com/VanshajPoonia/friday",
  },

  // {
  //   img: "https://user-images.githubusercontent.com/74147463/138559612-fd799884-b13f-4a51-9c94-1149f9c9dea5.png",
  //   name: "Snapchat clone",
  //   ext: "web.app",
  //   lang: "react",
  //   git: "https://github.com/VanshajPoonia/slapchat",
  //   live: "https://snapchat-12dbe.web.app",
  // },

  {
    img: "https://user-images.githubusercontent.com/74147463/138559776-2d01a85a-4eba-4969-9d5c-ac62a30c262f.png",
    name: "Bhhatsapp",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/bhhatsapp",
    live: "https://bhhatsapp.vercel.app/",
  },
  {
    img: "https://user-images.githubusercontent.com/74147463/138559821-24be00cb-e9c0-4589-a88b-d55e8c4c41ae.png",
    name: "Moogle maps",
    ext: "pages.dev",
    lang: "html n css",
    git: "https://github.com/VanshajPoonia/moogle-maps",
    live: "https://mooglemaps.pages.dev/",
  },
  {
    img: "https://i.ibb.co/dJY3YhD/Screenshot-1901.png",
    name: "Travello",
    ext: "netlify.app",
    lang: "react",
    git: "https://github.com/VanshajPoonia/travello",
    live: "https://travellooo.netlify.app/",
  },
  {
    img: "https://user-images.githubusercontent.com/74147463/138560043-d8d74c20-1b8c-4f1e-8cf4-41de87cab04d.png",
    name: "Moogle Drive",
    ext: "web.app",
    lang: "react",
    git: "https://github.com/VanshajPoonia/moogle-drive",
    live: "https://ggl-drive-1029.web.app/",
  },
  {
    img: "https://i.ibb.co/rsDbS4d/Screenshot-493.png",
    name: "Kelvin",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/kelvin",
    live: "https://kelvin.vercel.app",
  },
  {
    img: "https://user-images.githubusercontent.com/74147463/138560118-a8b7a159-fd5f-48be-83a9-59c97c37d5e6.png",
    name: "Mewtube",
    ext: "web.app",
    lang: "react",
    git: "https://github.com/VanshajPoonia/mewtube",
    live: "https://mewtube-op.web.app/",
  },

  {
    img: "https://i.ibb.co/Ms1574s/Screenshot-1909.png",
    name: "Discord UI Clone",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/discord-ui-clone-nextjs",
    live: "https://discord-ui-clone-nextjs.vercel.app/",
  },
  {
    img: "https://i.ibb.co/Zpycbvxs/Screenshot-2094.png",
    name: "SNS Towing",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/auto-vista-3d-rescue",
    live: "https://snstowingrecovery.vercel.app/",
  },
  {
    img: "https://i.ibb.co/q3FZLkqJ/Screenshot-2096.png",
    name: "Lauren Thomas",
    ext: "vercel.app",
    lang: "ssr",
    git: "https://github.com/VanshajPoonia/3d-portfolio",
    live: "https://lauren-thomas.vercel.app/",
  },
  {
    img: "https://i.ibb.co/92nct7y/Screenshot-1910.png",
    name: "Apple Landing Page",
    ext: "pages.dev",
    lang: "html n css",
    git: "https://github.com/VanshajPoonia/apple-landing-page",
    live: "https://apple-landing-page.pages.dev",
  },
  {
    img: "https://i.ibb.co/0Zph94S/Screenshot-1911.png",
    name: "Tulip",
    ext: "hypnosys.in",
    lang: "html n css",
    git: "https://github.com/VanshajPoonia/tulip-website",
    live: "https://tulip-website.pages.dev",
  },

  

  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/blog.jpg",
  //   name: "Django Blog",
  //   ext: "py",
  //   lang: "py",
  //   git: "https://github.com/smrnjeet222/Django_Blog",
  //   live: "https://smrnjeetblogs.herokuapp.com/",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/Python_Apps/master/Rock-Paper-Scissors/demo.jpg",
  //   name: "Multiplayer R.P.S",
  //   ext: "py",
  //   lang: "py,games",
  //   git: "https://github.com/smrnjeet222/Python_Apps/tree/master/Rock-Paper-Scissors",
  //   live: "https://github.com/smrnjeet222/Python_Apps/tree/master/Rock-Paper-Scissors",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/Python_Apps/master/Snake/Extras/play.png",
  //   name: "Snake Game",
  //   ext: "py",
  //   lang: "py,games",
  //   git: "https://github.com/smrnjeet222/Python_Apps/tree/master/Snake",
  //   live: "https://github.com/smrnjeet222/Python_Apps/tree/master/Snake",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/portfolio.png",
  //   name: "Old Portfolio",
  //   ext: "js",
  //   lang: "js",
  //   git: "https://github.com/smrnjeet222/Portfolio",
  //   live: "https://smrnjeet222.github.io/Portfolio/",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/surepass/bgvAll.png",
  //   name: "Surepass",
  //   ext: "jsx",
  //   lang: "js",
  //   git: "https://github.com/smrnjeet222/Surepass/blob/main/README.md",
  //   live: "https://github.com/smrnjeet222/Surepass/blob/main/README.md",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/Python_Apps/master/SudokuSolver/2.png",
  //   name: "Sudoku Solver",
  //   ext: "py",
  //   lang: "py,games",
  //   git: "https://github.com/smrnjeet222/Python_Apps/tree/master/SudokuSolver",
  //   live: "https://github.com/smrnjeet222/Python_Apps/tree/master/SudokuSolver",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/newslaundry.png",
  //   name: "Newslaundry",
  //   ext: "jsx",
  //   lang: "js",
  //   git: "https://github.com/smrnjeet222/newslaundry",
  //   live: "https://smrnjeet222.github.io/newslaundry/",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/recipe.jpg",
  //   name: "Recipe App",
  //   ext: "jsx",
  //   lang: "js",
  //   git: "https://github.com/smrnjeet222/recipe-app",
  //   live: "https://smrnjeet222.github.io/recipe-app/",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/bubblesort.png",
  //   name: "Visualisations",
  //   ext: "js",
  //   lang: "js",
  //   git: "https://editor.p5js.org/smrnjeet222/collections/fvtHa48dt",
  //   live: "https://editor.p5js.org/smrnjeet222/sketches/T0o5woDT5",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/covid.png",
  //   name: "Python Apps",
  //   ext: "py",
  //   lang: "py",
  //   git: "https://github.com/smrnjeet222/Python_Apps",
  //   live: "https://github.com/smrnjeet222/Python_Apps",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/background.gif",
  //   name: "DumpBox",
  //   ext: "jsx",
  //   lang: "js",
  //   git: "https://github.com/smrnjeet222/DropBox-Clone",
  //   live: "https://github.com/smrnjeet222/DropBox-Clone",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/pg.png",
  //   name: "Pico-Gram",
  //   ext: "jsx",
  //   lang: "js",
  //   git: "https://github.com/smrnjeet222/PicoGram",
  //   live: "https://smrnjeet-picogram.web.app/",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/BLENDER/master/Abstract_Design/Abstract.png",
  //   name: "Blender",
  //   ext: "models",
  //   lang: "games",
  //   git: "https://github.com/smrnjeet222/BLENDER",
  //   live: "https://smrnjeet222.github.io/BLENDER/",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/worldRanks.png",
  //   name: "WorldRanks",
  //   ext: "tsx",
  //   lang: "js",
  //   git: "https://github.com/smrnjeet222/WorldRanks",
  //   live: "https://world-ranks-smrnjeet222.vercel.app/",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/Unity_Gamedevelopment/master/MYGAME.png",
  //   name: "Unity Games",
  //   ext: "c#",
  //   lang: "games",
  //   git: "https://github.com/smrnjeet222/Unity_Gamedevelopment",
  //   live: "https://smrnjeet-22.itch.io/",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/background.gif",
  //   name: "NoJs-TicTacToe",
  //   ext: "css",
  //   lang: "js",
  //   git: "https://github.com/smrnjeet222/noJs-TicTacToe",
  //   live: "https://codepen.io/smrnjeet222/full/gOLjOXM",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/Automail.png",
  //   name: "AutoMail",
  //   ext: "py",
  //   lang: "py",
  //   git: "https://github.com/smrnjeet222/AutoMail",
  //   live: "https://github.com/smrnjeet222/AutoMail",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/Unity_Gamedevelopment/master/FreakyFrog/best.png",
  //   name: "Freaky Frog",
  //   ext: "c#",
  //   lang: "games",
  //   git: "https://github.com/smrnjeet222/Unity_Gamedevelopment",
  //   live: "https://smrnjeet-22.itch.io/freaky-frog",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/Astar.png",
  //   name: "A*Pathfinding",
  //   ext: "py",
  //   lang: "py",
  //   git: "https://github.com/smrnjeet222/Python_Apps/tree/master/A-star",
  //   live: "https://repl.it/@smrnjeet222/Astar#main.py",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/Python_Apps/master/Space-invaders/Sc.jpg",
  //   name: "Space-invaders",
  //   ext: "py",
  //   lang: "py,games",
  //   git: "https://github.com/smrnjeet222/Python_Apps/tree/master/Space-invaders",
  //   live: "https://github.com/smrnjeet222/Python_Apps/tree/master/Space-invaders",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/smrnjeet222/smrnjeet222/master/assets/Rc.png",
  //   name: "Ray Casting",
  //   ext: "js",
  //   lang: "js",
  //   git: "https://editor.p5js.org/smrnjeet222/collections/fvtHa48dt",
  //   live: "https://editor.p5js.org/smrnjeet222/sketches/j06TXs4ZF",
  // },
];
